import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import SideBar from '../../components/sideBar/SideBar';
import SideBarWrapper from "../../components/sideBar/SideBarWrapper";
import { toggleElement } from '../../stor/index';

const Layout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { toggleNav, setToggleNav } = toggleElement();
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024;
      setIsMobileView(isMobile);
      if (!isMobile) {
        setToggleNav(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setToggleNav]);

  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar 
        setToggleNav={setToggleNav} 
        isCollapsed={isCollapsed}
        isMobileView={isMobileView}
      />
      
      {/* ✅ Sidebar Wrapper */}
      <SideBarWrapper
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileView={isMobileView}
        toggleNav={toggleNav}
        setToggleNav={setToggleNav}
      />
      
      {/* Main Content */}
      <main 
        className={`
          pt-16 transition-all duration-300 
          ${!isMobileView ? (isCollapsed ? 'lg:mr-20' : 'lg:mr-60') : 'lg:mr-0'}
          ${toggleNav ? 'opacity-50' : 'opacity-100'}
        `}
      >
        <div className="container mx-auto   py-14 md:py-4 min-h-screen ">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;